import { httpRequest } from "@services/http";

export class CommandDeleteJourneyStep {
  async run(journeyId: number, stepId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/journeys/${journeyId}/steps/${stepId}/`;
    return await httpRequest<any>(url, { method: "DELETE" });
  }
}
